// Form validation
import ValidateForm from '../lib/form-validation';

document.querySelectorAll('form.js-validate').forEach(el => new ValidateForm(el));
